import { Machine, State } from 'xstate';

import FB from '~/api/core/facebook';

import { sendErrorService } from '~/services/error';

export interface TosContext {
  interval: number,
  pageId: string,
}

export interface TosSchema {
  states: {
    closed: {};
    open: {
      states: {
        instructions: {};
        awaitingFBResponse: {};
      };
    };
    tosAccepted: {};
  };
}

export type TosEvent =
  | { type: 'MODAL.open' }
  | { type: 'MODAL.close' }
  | { type: 'TOS.beginPolling' }
  | { type: 'TOS.accepted' };

export type TosState = State<TosContext, TosEvent, TosSchema>;

export default Machine<TosContext, TosSchema, TosEvent>({
  id: 'lead-ad-tos',
  initial: 'closed',
  states: {
    closed: {
      on: {
        'MODAL.open': 'open',
      },
    },
    open: {
      initial: 'instructions',
      states: {
        instructions: {
          on: {
            'TOS.beginPolling': 'awaitingFBResponse',
          },
        },
        awaitingFBResponse: {
          invoke: {
            src: 'pingFacebook',
          },
          on: {
            'TOS.accepted': {
              target: '#lead-ad-tos.tosAccepted',
            },
          },
        },
      },
      on: {
        'MODAL.close': 'closed',
      },
    },
    tosAccepted: {
      type: 'final',
    },
  },
}, {
  services: {
    pingFacebook: ctx => (callback) => {
      const askFbTosAccepted = () => {
        FB(`/${ctx.pageId}?fields=leadgen_tos_accepted`, 'get')
          .then((r) => {
            if (r.leadgen_tos_accepted) {
              callback('TOS.accepted');
            }
          })
          .catch((e) => {
            sendErrorService(new Error('Cannot retrieve ToS status from FB'), 'lead-ad-tos', e);
          });
      };

      const interval = setInterval(askFbTosAccepted, ctx.interval);

      return () => clearInterval(interval);
    },
  },
});
